import { DateTime } from 'luxon';
import { Observable } from 'rxjs';

import { Task } from 'task/task';

export abstract class TaskRepositoryPort {
	public abstract deleteTask(id: string): Promise<void>;

	public abstract observeContactTasks(contactId: string): Observable<Task[]>;

	public abstract observeJobOfferTasks(jobOfferId: string): Observable<Task[]>;

	public abstract observeTask(id: string): Observable<Task>;

	public abstract saveTasks(tasks: Task[]): Promise<void>;

	public abstract observeUserPendingTasks(userId: string): Observable<Task[]>;

	public abstract observeTasks(tasksId: string[]): Observable<Task[]>;

	public abstract observeUserOverdueTasks(userId: string): Observable<Task[]>;

	public abstract observeUserDayTasks(
		userId: string,
		date: DateTime
	): Observable<Task[]>;
}
